// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3306":"51e36e84","3815":"25171748","4990":"5091ce02","7086":"3538c4fb","7998":"25171748","8205":"ae63a90f"}[chunkId] + ".chunk.css";
};